import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AffiliateEventRequest, AffiliateRequest, SchemaPointRequest, SchemaPointResponse } from '../models/affiliate.model';

@Injectable({
	providedIn: 'root'
})
export class AffiliatePointHistoryService {
	private url = environment.api + "api/erp/affiliate-points-history";
	constructor(
		private http: HttpClient,
	) { }

	getHistoryByCompany() {
		return this.http.get(this.url);
	}

	getHistoryByCompanyAndAffiliate(affiliateId: any) {
		return this.http.get(this.url + "/affiliate/" + affiliateId);
	}

	getHistoryByCompanyAndDate(startDate: string, endDate: string) {
		return this.http.get(this.url + `/dates/${startDate}/${endDate}`);
	}

	getHistoryByCompanyAndAffiliateAndDate(affiliateId: any, startDate: string, endDate: string) {
		return this.http.get(this.url + "/affiliate/" + affiliateId + `/dates/${startDate}/${endDate}`);
	}
}